import React, { useState, } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import toast from 'react-hot-toast';
import validator from 'validator';
//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useDispatch } from "react-redux";
import { addUser, } from '../../../redux/feature/userSlice';
import Layout from '../../../Layout/Layout';
import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import { InputField } from '../../../Components/formElements/InputField';

const ProductMatrixCreationP2 = () => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');


  const [formInputs, setFormInputs] = useState({
    baseUnitPrice: "",
    baseUnit: "",
    siteArtlStatus: "",
    artl: "",
    assignEffect: "",
    assignEffectVals: "",
    mdseCategory: "",
    mdse: "",
    exMdseCategory: "",
    exMdse: "",
    officeLab: "",
    labOffice: "",
    hierarchy: "",
    productHirarchy: "",
    validFrom2: "",
    validFrom: "",
    genitmCatGroup: "",
    genitmCat: "",
    group1: "",
    authorizationGroup: "",
    weig: "",
    netWeightht: "",
    grossWeight: "",
    eanUpc: "",
    sizeDimensions: "",
    volumeUnit: "",
    volume: "",
  });
  localStorage.setItem('menu', '');
  localStorage.setItem('submenu', '-');

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
  };

  const onInputChangePhone = ({ target: { name, value } }) => {
    if (validator.isNumeric(value) || value === "") {
      setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async () => {

    if (formInputs.firstName === "" || formInputs.lastName === "" || formInputs.contactNumber === "") {
      setErrorMsg('* Fields are mandatory');
      return;
    } else {
      setErrorMsg("")
    }

    const data = {
      "firstName": formInputs?.firstName,
      "lastName": formInputs?.lastName,
      "contactNumber": formInputs?.contactNumber,
      "companyName": formInputs?.companyName,
      "category": formInputs?.category,
      "organisationName": formInputs?.organisationName,
      "status": formInputs?.status,
      "city": formInputs.city,
      "country": formInputs?.country,
      "address": formInputs?.address,
      "address2": formInputs?.address2,
      "state": formInputs?.state,
      "cityPostalCode": formInputs?.cityPostalCode,
      "roleId": formInputs?.roleId,
      "_id": formInputs._id,
      "action": "Profile"
    };
    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });

    setDisabled(true);
    await ItemService.userUpdate(data).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || 'User Updated successfully', {
          duration: 2000,
          position: 'top-right',
        });

        // Update response value in Redux Store
        dispatch(addUser(data))

      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }
      setDisabled(false);

    });
    toast.dismiss(toastId);
  };


  const handleSavePassword = async () => {

    if (formInputs.password === "" || formInputs.newPassword === "" || formInputs.confirmPassword === "") {
      setErrorMsg('* Fields are mandatory');
      return;
    } else {
      setErrorMsg("")
    }

    if (formInputs.newPassword !== formInputs.confirmPassword) {
      setErrorMsg('* New and Confirm Password Not Matching');
      return;
    }

    const data = {
      "password": formInputs.password,
      "confirmPassword": formInputs.confirmPassword,
      "_id": formInputs?._id,
      "role": formInputs?.role,
      "action": "Change_Password"
    };

    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });

    setDisabled(true);
    await ItemService.userUpdate(data).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || 'User Updated successfully', {
          duration: 2000,
          position: 'top-right',
        });

        // Update response value in Redux Store
        dispatch(addUser(data))
      } else {
        setErrorMsg('*' + item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }
      setDisabled(false);
    });
    toast.dismiss(toastId);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className='justify-center subContent'>
        <Col xs={12} md={12} lg={12} className="rightSide">

          <div className="rightSideInner PageCommonCSS">
            <h2 className='mainTitle'>Product Article Creataion</h2>
            <p className='subText'>Product Article Creataion.</p>
            <hr />

            <section className="section profile">
              <div className="row">

                <div className="col-xl-12">
                  {/* card 1 */}
                  <div className="card ">
                    <div className="card-body pt-3">

                      {/* nav link section */}
                      <ul className="nav nav-tabs nav-tabs-bordered">
                        <li className="nav-item">
                          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#basicData">Basic Data</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#basicDataFashion">Basic Data: Fashion</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#dimension">Basic Data: Attribute</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsDc">Logistics: DC</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsDcFashion">Logistics: DC Fashion</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsStore">Logistics: Store(Accounting)</button>
                        </li>
                      </ul>
                      {/* Basic Data */}
                      <div className="tab-content pt-2">
                        <div className="tab-pane fade show active profile-overview profile-edit" id="basicData">
                          {/* Over view */}
                          <div className="tab-pane fade show active profile-overview" id="basicData">

                            <form>
                              <Row className=''>

                                <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>

                                  <h5 className="card-title" style={{ color: '#012970' }}>General Data</h5>
                                  <hr />
                                  <div className="row mb-3">
                                    <label for="articleNr" className="col-md-4 col-lg-3 col-form-label">Article Nr</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="articleNr" type="text" className="form-control" id="articleNr" value={formInputs.articleNr || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="articleDesc" className="col-md-4 col-lg-3 col-form-label">Article Description</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="articleDesc" type="text" className="form-control" id="articleDesc" value={formInputs.articleDesc || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="division" className="col-md-4 col-lg-3 col-form-label">Division</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="division1"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.division1 || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>

                                        <input name="division" type="text" className="form-control" id="category" value={formInputs.division || ""} onChange={onInputChange} disabled={false} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="articleType" className="col-md-4 col-lg-3 col-form-label">Article Type</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="articleType"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.articleType || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>
                                        <input name="articleType" type="text" className="form-control" id="articleType" value={formInputs.articleType || ""} onChange={onInputChange} disabled={false} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="brand" className="col-md-4 col-lg-3 col-form-label">Brand</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="brand" type="text" className="form-control" id="brand" value={formInputs.brand || ""} onChange={onInputChange} />
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <label for="commodityCode" className="col-md-4 col-lg-3 col-form-label">Commodity Code</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="commodityCode" type="text" className="form-control" id="commodityCode" value={formInputs.commodityCode || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="OldArticleNr" className="col-md-4 col-lg-3 col-form-label">Old Article Number</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="oldArticleNr" type="text" className="form-control" id="oldArticleNr" value={formInputs.oldArticleNr || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="externalMerchandiseCat" className="col-md-4 col-lg-3 col-form-label">External Merchandise Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="externalMerchandiseCat" type="text" className="form-control" id="externalMerchandiseCat" value={formInputs.externalMerchandiseCat || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextilesC1" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 1)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fiberCodeTextilesC1" type="text" className="form-control" id="fiberCodeTextilesC1" value={formInputs.fiberCodeTextilesC1 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareFiberC1" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 1)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="percentageShareFiberC1" type="text" className="form-control" id="percentageShareFiberC1" value={formInputs.percentageShareFiberC1 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextilesC2" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 2)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fiberCodeTextilesC2" type="text" className="form-control" id="fiberCodeTextilesC2" value={formInputs.fiberCodeTextilesC2 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareFiberC2" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 2)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="percentageShareFiberC2" type="text" className="form-control" id="percentageShareFiberC2" value={formInputs.percentageShareFiberC2 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextilesC3" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 3)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fiberCodeTextilesC3" type="text" className="form-control" id="fiberCodeTextilesC3" value={formInputs.fiberCodeTextilesC3 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareFiberC3" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 3)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="percentageShareFiberC3" type="text" className="form-control" id="percentageShareFiberC3" value={formInputs.percentageShareFiberC3 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextilesC4" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 4)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fiberCodeTextilesC4" type="text" className="form-control" id="fiberCodeTextilesC4" value={formInputs.fiberCodeTextilesC4 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareFiberC4" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 4)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="percentageShareFiberC4" type="text" className="form-control" id="percentageShareFiberC4" value={formInputs.percentageShareFiberC4 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextilesC5" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 5)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fiberCodeTextilesC5" type="text" className="form-control" id="fiberCodeTextilesC5" value={formInputs.fiberCodeTextilesC5 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareFiberC5" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 5)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="percentageShareFiberC5" type="text" className="form-control" id="percentageShareFiberC5" value={formInputs.percentageShareFiberC5 || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="countryOriginArticle" className="col-md-4 col-lg-3 col-form-label">Country of Origin of Article</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="countryOriginArticle" type="text" className="form-control" id="countryOriginArticle" value={formInputs.countryOriginArticle || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fashionGrade" className="col-md-4 col-lg-3 col-form-label">Fashion Grade</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="fashionGrade" type="text" className="form-control" id="fashionGrade" value={formInputs.fashionGrade || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                  <h5 className="card-title" style={{ color: '#012970' }}> Article Group</h5>
                                  <hr />
                                  <div className="row mb-3">
                                    <label for="authorizationGroup" className="col-md-4 col-lg-3 col-form-label">Authorization Group</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="group1"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.group1 || ""}
                                            onChange={onInputChange}
                                          />

                                        </div>

                                        <input name="authorizationGroup" type="text" className="form-control" id="authorizationGroup" value={formInputs.authorizationGroup || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="artcleCategory" className="col-md-4 col-lg-3 col-form-label">Article Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="artcleCategory"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.artcleCategory || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>
                                        <input name="artcleCategory" type="text" className="form-control" id="artcleCategory" value={formInputs.artcleCategory || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="merchandiseCategory" className="col-md-4 col-lg-3 col-form-label">Merchandise Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="merchandiseCategory"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.merchandiseCategory || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>
                                        <input name="merchandiseCategory" type="text" className="form-control" id="merchandiseCategory" value={formInputs.merchandiseCategory || ""} onChange={onInputChange} disabled={false} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="externalMerchandiseCat" className="col-md-4 col-lg-3 col-form-label">External Merchandise Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="externalMerchandiseCat" type="text" className="form-control" id="externalMerchandiseCat" value={formInputs.externalMerchandiseCat || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="characteristicprofile" className="col-md-4 col-lg-3 col-form-label">Characteristic profile</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="characteristicprofile"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.characteristicprofile || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>
                                        <input name="characteristicprofile" type="text" className="form-control" id="characteristicprofile" value={formInputs.characteristicprofile || ""} onChange={onInputChange} disabled={false} />
                                      </div>
                                    </div>
                                  </div>
                                  <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Dimensions/EANS</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="basicUnitMeasure" className="col-md-2 col-lg-2 col-form-label">Base Unit of Measure</label>
                                      <div className="col-md-8 col-lg-9">
                                        <input name="basicUnitMeasure" type="text" className="form-control" id="basicUnitMeasure" value={formInputs.basicUnitMeasure || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="grossWeight" className="col-md-2 col-lg-2 col-form-label">Gross Weight</label>
                                      <div className="col-md-8 col-lg-9">
                                        <input name="grossWeight" type="text" className="form-control" id="grossWeight" value={formInputs.grossWeight || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="netWeight" className="col-md-2 col-lg-2 col-form-label">Net Weight</label>
                                      <div className="col-md-8 col-lg-9">
                                        <input name="netWeight" type="text" className="form-control" id="netWeight" value={formInputs.netWeight || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="weightUnit" className="col-md-2 col-lg-2 col-form-label">Weight Unit</label>
                                      <div className="col-md-8 col-lg-9">
                                        <input name="weightUnit" type="text" className="form-control" id="weightUnit" value={formInputs.weightUnit || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="taxClassification" className="col-md-2 col-lg-2 col-form-label">Tax Classification</label>
                                      <div className="col-md-8 col-lg-9">
                                        <input name="taxClassification" type="text" className="form-control" id="taxClassification" value={formInputs.taxClassification || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </Col>
                                </Col>
                              </Row>
                            </form>
                          </div>
                        </div>
                        {/* Basic Data: Fashions */}
                        <div className="tab-pane fade profile-edit pt-3" id="basicDataFashion">
                          <form>
                            <div className="row mb-3">
                              {/* <label for="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label> */}
                              <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                <h5 className="card-title" style={{ color: '#012970' }}>Fashion Attributes</h5>
                                <hr />
                                <div className="row mb-3">
                                  <label htmlFor="styleCode" className="col-md-4 col-lg-3 col-form-label">Style</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="styleCode1"
                                        type="text"
                                        className="form-control"
                                        id="netWeight"
                                        value={formInputs.styleCode1 || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="styleCode"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.styleCode || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fashionCollection" className="col-md-4 col-lg-3 col-form-label">Fashion Collection</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fashionCollection"
                                        type="text"
                                        className="form-control"
                                        id="fashionCollection"
                                        value={formInputs.fashionCollection || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fashionCollection"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fashionCollection || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fashionTheme" className="col-md-4 col-lg-3 col-form-label">Fashion Theme</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fashionTheme"
                                        type="text"
                                        className="form-control"
                                        id="fashionTheme"
                                        value={formInputs.fashionTheme || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fashionTheme"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fashionTheme || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="seasonIndicator" className="col-md-4 col-lg-3 col-form-label">Season Indicator</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="seasonIndicator"
                                        type="text"
                                        className="form-control"
                                        id="seasonIndicator"
                                        value={formInputs.seasonIndicator || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="seasonIndicator"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.seasonIndicator || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fabricContent" className="col-md-4 col-lg-3 col-form-label">Fabric Content</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fabricContent"
                                        type="text"
                                        className="form-control"
                                        id="fabricContent"
                                        value={formInputs.fabricContent || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fabricContent1"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fabricContent1 || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <form>
                                <Row className=''>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>

                                    <h5 className="card-title" style={{ color: '#012970' }}>Segmentation Data</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label htmlFor="sigmantRelavant" className="col-md-4 col-lg-3 col-form-label">Segment Relevant</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="form-check">
                                          <input
                                            name="sigmantRelavant"
                                            type="checkbox"
                                            className="form-check-input"
                                            id="sigmantRelavant"
                                            checked={formInputs.sigmantRelavant || false}  // Checkbox is checked only if true
                                            onChange={onInputChange}
                                          />
                                          <label className="form-check-label" htmlFor="sigmantRelavant">
                                            Yes
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Segmentation Structure</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="segmantationStructure1"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.segmantationStructure1 || ""}
                                              onChange={onInputChange}
                                            />

                                          </div>

                                          <input name="segmantationStructure" type="text" className="form-control" id="category" value={formInputs.segmantationStructure || ""} onChange={onInputChange} disabled={false} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmantStrategy" className="col-md-4 col-lg-3 col-form-label">Segmentation Strategy</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="segmantStrategy1"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.segmantStrategy1 || ""}
                                              onChange={onInputChange}
                                            />

                                          </div>

                                          <input name="segmantStrategy" type="text" className="form-control" id="segmantStrategy" value={formInputs.segmantStrategy || ""} onChange={onInputChange} disabled={false} />
                                        </div>
                                      </div>
                                    </div>
                                    <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                      <h5 className="card-title" style={{ color: '#012970' }}>Season AssignMent</h5>
                                      <hr />
                                      <div className="row mb-3">
                                        <label htmlFor="season" className="col-md-4 col-lg-3 col-form-label">Season</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="season"
                                              type="text"
                                              className="form-control"
                                              id="season"
                                              value={formInputs.season || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label htmlFor="seasonCategory" className="col-md-4 col-lg-3 col-form-label">Season Category</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="seasonCategory"
                                              type="text"
                                              className="form-control"
                                              id="seasonCategory"
                                              value={formInputs.seasonCategory || ""}
                                              onChange={onInputChange}
                                            />

                                            {/* Small input field next to the main one */}
                                            <div className="input-group-append ml-2">
                                              <input
                                                name="group1"
                                                type="text"
                                                className="form-control form-control-m ml-2"  // Small input field
                                                value={formInputs.group1 || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label htmlFor="segment" className="col-md-4 col-lg-3 col-form-label">Segment</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="segment"
                                              type="text"
                                              className="form-control"
                                              id="segment"
                                              value={formInputs.segment || ""}
                                              onChange={onInputChange}
                                            />

                                            {/* Small input field next to the main one */}
                                            <div className="input-group-append ml-2">
                                              <input
                                                name="segment1"
                                                type="text"
                                                className="form-control form-control-m ml-2"  // Small input field
                                                value={formInputs.segment1 || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label htmlFor="seasonYear" className="col-md-4 col-lg-3 col-form-label">Season year</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="seasonYear"
                                              type="text"
                                              className="form-control"
                                              id="seasonYear"
                                              value={formInputs.seasonYear || ""}
                                              onChange={onInputChange}
                                            />

                                            {/* Small input field next to the main one */}
                                            <div className="input-group-append ml-2">
                                              <input
                                                name="seasonYear"
                                                type="text"
                                                className="form-control form-control-m ml-2"  // Small input field
                                                value={formInputs.seasonYear || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>

                                  </Col>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Article Conversion ID</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="artConv" className="col-md-4 col-lg-3 col-form-label">Article.Conv.ID</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="artConv"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.artConv || ""}
                                              onChange={onInputChange}
                                            />

                                          </div>

                                          <input name="artConv" type="text" className="form-control" id="artConv" value={formInputs.artConv || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>

                                  </Col>
                                </Row>
                              </form>
                            </div>
                            {/* <h5 className="card-title" style={{ color: '#012970' }}>Basic Data Fashions</h5> */}

                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save</button>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>

                        {/* Basic data attribute  */}
                        <div className="tab-pane fade profile-edit pt-3" id="dimension">
                          <form>
                            <div className="row mb-3">
                              {/* <label for="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label> */}
                              <form>
                                <Row className=''>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>

                                    <h5 className="card-title" style={{ color: '#012970' }}>Attribute Data 1</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Gender</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="gender"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.gender || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="gender" type="text" className="form-control" id="category" value={formInputs.gender || ""} onChange={onInputChange} disabled={false} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmantStrategy" className="col-md-4 col-lg-3 col-form-label">Sub Gender</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="subGender"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.subGender || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="subGender" type="text" className="form-control" id="subGender" value={formInputs.subGender || ""} onChange={onInputChange} disabled={false} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="styleDesc" className="col-md-4 col-lg-3 col-form-label">Style Description</label>
                                        <div className="col-md-8 col-lg-9">
                                          <input name="styleDesc" type="text" className="form-control" id="styleDesc" value={formInputs.styleDesc || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="mrp" className="col-md-4 col-lg-3 col-form-label">Multiple MRP</label>
                                        <div className="col-md-8 col-lg-9">
                                          <input name="mrp" type="text" className="form-control" id="mrp" value={formInputs.mrp || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Color</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}
                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <input
                                                name="color"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.color || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="color" type="text" className="form-control" id="category" value={formInputs.color || ""} onChange={onInputChange} disabled={false} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                      <h5 className="card-title" style={{ color: '#012970' }}>Attribute 3</h5>
                                      <hr />
                                      <div className="row mb-3">
                                        <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Fit</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}

                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <input
                                                name="fit"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.fit || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="fit" type="text" className="form-control" id="fit" value={formInputs.fit || ""} onChange={onInputChange} disabled={false} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Fit Name</label>
                                          <div className="col-md-8 col-lg-9">
                                            <div className="input-group ">
                                              {/* Small input field with inside */}

                                              <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                                <input
                                                  name="fitName"
                                                  type="text"
                                                  className="form-control pe-4"
                                                  value={formInputs.fitName || ""}
                                                  onChange={onInputChange}
                                                />
                                              </div>
                                              <input name="fitName" type="text" className="form-control" id="fitName" value={formInputs.fitName || ""} onChange={onInputChange} disabled={false} />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="designCode" className="col-md-4 col-lg-3 col-form-label">Design Code</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="designCode" type="text" className="form-control" id="designCode" value={formInputs.designCode || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="designType" className="col-md-4 col-lg-3 col-form-label">Design Type</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="designType" type="text" className="form-control" id="designType" value={formInputs.designType || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="collorNeckPleate" className="col-md-4 col-lg-3 col-form-label">Collor/Neck/pleate</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="collorNeckPleate" type="text" className="form-control" id="collorNeckPleate" value={formInputs.collorNeckPleate || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="sleev" className="col-md-4 col-lg-3 col-form-label">Sleev</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="sleev" type="text" className="form-control" id="sleev" value={formInputs.sleev || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="occasion" className="col-md-4 col-lg-3 col-form-label">Occasion</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="occasion" type="text" className="form-control" id="occasion" value={formInputs.occasion || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="garmentFinish" className="col-md-4 col-lg-3 col-form-label">Garment Finish</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="garmentFinish" type="text" className="form-control" id="garmentFinish" value={formInputs.garmentFinish || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="inseam" className="col-md-4 col-lg-3 col-form-label">Inseam</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="inseam" type="text" className="form-control" id="inseam" value={formInputs.inseam || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="subLabel" className="col-md-4 col-lg-3 col-form-label">Sub label</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="subLabel" type="text" className="form-control" id="subLabel" value={formInputs.subLabel || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="categoryGroup" className="col-md-4 col-lg-3 col-form-label">Category Group</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="categoryGroup" type="text" className="form-control" id="categoryGroup" value={formInputs.categoryGroup || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="subCategoryGroup" className="col-md-4 col-lg-3 col-form-label">Sub Category Group</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="subCategoryGroup" type="text" className="form-control" id="subCategoryGroup" value={formInputs.subCategoryGroup || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="categoryType" className="col-md-4 col-lg-3 col-form-label">Category type</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="categoryType" type="text" className="form-control" id="categoryType" value={formInputs.categoryType || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="selable" className="col-md-4 col-lg-3 col-form-label">Selable</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="selable" type="text" className="form-control" id="selable" value={formInputs.selable || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="returanable" className="col-md-4 col-lg-3 col-form-label">Returanable</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="returanable" type="text" className="form-control" id="returanable" value={formInputs.returanable || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class1" className="col-md-4 col-lg-3 col-form-label">Class 1</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="class1" type="text" className="form-control" id="class1" value={formInputs.class1 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class2" className="col-md-4 col-lg-3 col-form-label">Class 2</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="class2" type="text" className="form-control" id="class2" value={formInputs.class2 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class3" className="col-md-4 col-lg-3 col-form-label">Class 3</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="class3" type="text" className="form-control" id="class3" value={formInputs.class3 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class4" className="col-md-4 col-lg-3 col-form-label">Class 4</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="class4" type="text" className="form-control" id="class4" value={formInputs.class4 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarCode1" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 1</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="freeTextBarCode1" type="text" className="form-control" id="freeTextBarCode1" value={formInputs.freeTextBarCode1 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarCode2" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 2</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="freeTextBarCode2" type="text" className="form-control" id="freeTextBarCode2" value={formInputs.freeTextBarCode2 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarCode3" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 3</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="freeTextBarCode3" type="text" className="form-control" id="freeTextBarCode3" value={formInputs.freeTextBarCode3 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="warpCount" className="col-md-4 col-lg-3 col-form-label">Wrap Count</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="warpCount" type="text" className="form-control" id="warpCount" value={formInputs.warpCount || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="weftCount" className="col-md-4 col-lg-3 col-form-label">Weaft Count</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="weftCount" type="text" className="form-control" id="weftCount" value={formInputs.weftCount || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="endsPerInch" className="col-md-4 col-lg-3 col-form-label">Ends Per Inch</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="endsPerInch" type="text" className="form-control" id="endsPerInch" value={formInputs.endsPerInch || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="picksPerInch" className="col-md-4 col-lg-3 col-form-label">Picks Per Inch</label>
                                          <div className="col-md-8 col-lg-9">
                                            <input name="picksPerInch" type="text" className="form-control" id="picksPerInch" value={formInputs.picksPerInch || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Col>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Attribute 2</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Finish</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricFinish"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricFinish || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricFinish" type="text" className="form-control" id="fabricFinish" value={formInputs.fabricFinish || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Code</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricCode"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricCode || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricCode" type="text" className="form-control" id="fabricCode" value={formInputs.fabricCode || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Type</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricType"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricType || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricType" type="text" className="form-control" id="fabricType" value={formInputs.fabricType || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Weave</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}
                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <input
                                                name="weave"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.weave || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="weave" type="text" className="form-control" id="weave" value={formInputs.weave || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Yarn Type</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="yarnType"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.yarnType || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="yarnType" type="text" className="form-control" id="yarnType" value={formInputs.yarnType || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Leather</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="leather"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.leather || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="leather" type="text" className="form-control" id="leather" value={formInputs.leather || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </form>
                            </div>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save</button>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>

                        {/* gtinEan */}
                        <div className="tab-pane fade pt-3" id="gtinEan">
                          <form>
                            <h5 className="card-title" style={{ color: '#012970' }}>gtin</h5>

                            <div className="row mb-3">
                              <label for="currentPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Old Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="password" type="password" className="form-control" id="password" value={formInputs.password || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <label for="newPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="newPassword" type="password" className="form-control" id="newPass" value={formInputs.newPassword || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="renewPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Re-enter New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="confirmPassword" type="password" className="form-control" id="confirmPassword" value={formInputs.confirmPassword || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Save</button>
                            </div>
                          </form>
                        </div>
                        {/* basicText */}
                        <div className="tab-pane fade pt-3" id="basicText">
                          <form>
                            <h5 className="card-title" style={{ color: '#012970' }}>basicText</h5>

                            <div className="row mb-3">
                              <label for="currentPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Old Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="password" type="password" className="form-control" id="password" value={formInputs.password || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <label for="newPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="newPassword" type="password" className="form-control" id="newPass" value={formInputs.newPassword || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="renewPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Re-enter New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="confirmPassword" type="password" className="form-control" id="confirmPassword" value={formInputs.confirmPassword || ""}
                                  onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Save</button>
                            </div>
                          </form>
                        </div>

                        {/* Logistic dc */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsDc">
                          <form>
                            <h5 className="card-title" style={{ color: '#012970' }}>Logistics Dc</h5>
                            <div className="row mb-3">
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="storageSec" className="col-form-label me-7">Storage Sect.ID</label>
                                    <input
                                      name="storageSec"
                                      type="text"
                                      className="form-control"
                                      id="storageSec"
                                      value={formInputs.storageSec || ""}
                                      onChange={onInputChange}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="stockPlacement" className="col-form-label me-3">Stock placement</label>
                                    <input
                                      name="stockPlacement"
                                      type="text"
                                      className="form-control"
                                      id="stockPlacement"
                                      value={formInputs.stockPlacement || ""}
                                      onChange={onInputChange}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="stockRemoval" className="col-form-label me-3">Stock removal</label>
                                    <input
                                      name="stockRemoval"
                                      type="text"
                                      className="form-control"
                                      id="stockRemoval"
                                      value={formInputs.stockRemoval || ""}
                                      onChange={onInputChange}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <form>
                              </form>
                            </div>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Save</button>
                            </div>
                          </form>
                        </div>
                        {/* Logoistic Store Accounting */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsStore">
                          <form>
                            <div className="row mb-3">
                              <form>
                                <div className="row mb-3">
                                  <label for="futurePlannedPrice1" className="col-md-4 col-lg-3 col-form-label">Future Planned Price 1</label>
                                  <div className="col-md-8 col-lg-9">
                                    <input name="futurePlannedPrice1" type="text" className="form-control" id="futurePlannedPrice1" value={formInputs.futurePlannedPrice1 || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label for="dateForValidFuturePlaned1" className="col-md-4 col-lg-3 col-form-label">Date from Which Future Planned Price 1 Is Valid</label>
                                  <div className="col-md-8 col-lg-9">
                                    <input name="dateForValidFuturePlaned1" type="text" className="form-control" id="dateForValidFuturePlaned1" value={formInputs.dateForValidFuturePlaned1 || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label for="controlCodeConsumptionTax" className="col-md-4 col-lg-3 col-form-label">Control code for consumption taxes in foreign trade</label>
                                  <div className="col-md-8 col-lg-9">
                                    <input name="controlCodeConsumptionTax" type="text" className="form-control" id="controlCodeConsumptionTax" value={formInputs.controlCodeConsumptionTax || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                              </form>
                            </div>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Save</button>
                            </div>
                          </form>
                        </div>
                        {/* Logistic DC fashionn */}
                        {/* Logistic dc */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsDcFashion">
                          <form>
                            {/* <h5 className="card-title" style={{ color: '#012970' }}>Logistics Dc</h5> */}
                            <Col sm={12} md={12} lg={12} className='p-4'>
                              <div className="row mb-3">
                                <label for="indicatorInventory" className="col-md-2 col-lg-2 col-form-label">Indicator: Season Active in Inventory Management</label>
                                <div className="col-md-4 col-lg-4">
                                  <input name="indicatorInventory" type="text" className="form-control" id="indicatorInventory" value={formInputs.indicatorInventory || ""} onChange={onInputChange} />
                                </div>
                              </div>
                            </Col>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Save</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* card 2 */}
                  <div className="card ">
                    <div className="card-body pt-3">

                      {/* nav link section */}
                      <ul className="nav nav-tabs nav-tabs-bordered">
                        <li className="nav-item">
                          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#purchasing">Purchasing</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#purchasingOrderText">Purchasing Order Text</button>
                        </li>
                        {/*  */}
                      </ul>
                      {/* Pur CHasing */}
                      <div className="tab-content pt-2">
                        <div className="tab-pane fade show active profile-overview" id="purchasing">
                          {/* Over view */}
                          <div className="tab-pane fade show active profile-overview" id="purchasing">

                            <form>
                              <Row>

                                <Col sm={12} md={12} lg={12} className='p-4'>
                                  <h5 className="card-title" style={{ color: '#012970' }}>Purchasing</h5>
                                  <hr />
                                  <div className="row mb-3">
                                    <label for="Company" className="col-md-4 col-lg-3 col-form-label">order unit</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with icon inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="roleKey2"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.roleKey2 || ""}
                                            onChange={onInputChange}
                                          />

                                        </div>
                                        <input name="companyName2" type="text" className="form-control" id="companyName2" value={formInputs.companyName2 || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <label for="Organisation" className="col-md-4 col-lg-3 col-form-label">Purchasing Order Key</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with icon inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="roleKey1"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.roleKey1 || ""}
                                            onChange={onInputChange}
                                          />

                                        </div>
                                        <input name="organisationName1" type="text" className="form-control" id="organisationName1" value={formInputs.organisationName1 || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="category" className="col-md-4 col-lg-3 col-form-label">Variable Purchase Order</label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group">

                                        <div className="input-group ">
                                          {/* Small input field with icon inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <ComboboxField
                                              name="roleKey"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.roleKey || ""}
                                              onChange={onInputChange}
                                            />

                                          </div>

                                          {/* Main input field (category) */}
                                          <input
                                            name="category"
                                            type="text"
                                            className="form-control"
                                            id="category"
                                            value={formInputs.category || ""}
                                            onChange={onInputChange}
                                          />
                                        </div>


                                      </div>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <label htmlFor="roleId" className="col-md-4 col-lg-3 col-form-label">
                                      Add Permanent Ac
                                    </label>
                                    <div className="col-md-8 col-lg-9">
                                      <div className="input-group ">
                                        {/* Small input field with icon inside */}

                                        <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                          <ComboboxField
                                            name="roleKey"
                                            type="text"
                                            className="form-control pe-4"
                                            value={formInputs.roleKey || ""}
                                            onChange={onInputChange}
                                          />

                                        </div>

                                        {/* Main input field */}
                                        <input
                                          name="roleId"
                                          type="text"
                                          className="form-control"
                                          value={formInputs.roleId || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </form>
                          </div>
                        </div>

                        {/* Purchasing Order Text*/}
                        <div className="tab-pane fade profile-edit pt-3" id="purchasingOrderText">
                          <form>
                            <div className="row mb-3">
                              {/* <label for="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label> */}

                            </div>
                            <h5 className="card-title" style={{ color: '#012970' }}>Company</h5>
                            <div className="row mb-3">
                              <label for="Company" className="col-md-4 col-lg-3 col-form-label">Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="companyName" type="text" className="form-control" id="companyName" value={formInputs.companyName || ""} onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <label for="Organisation" className="col-md-4 col-lg-3 col-form-label">Organisation</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="organisationName" type="text" className="form-control" id="organisationName" value={formInputs.organisationName || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="category" className="col-md-4 col-lg-3 col-form-label">Category</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="category" type="text" className="form-control" id="category" value={formInputs.category || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="roleId" className="col-md-4 col-lg-3 col-form-label">Role</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="roleId" type="text" className="form-control" id="roleId" value={formInputs.roleId || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>

                            <h5 className="card-title" style={{ color: '#012970' }}>Profile</h5>
                            <div className="row mb-3">
                              <label for="firstName" className="col-md-4 col-lg-3 col-form-label">First Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="firstName" type="text" className="form-control" id="firstName" value={formInputs.firstName || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="lastName" className="col-md-4 col-lg-3 col-form-label">Last Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="lastName" type="text" className="form-control" id="lastName" value={formInputs.lastName || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="email" className="col-md-4 col-lg-3 col-form-label">Email Id</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="email" type="text" className="form-control" id="email" value={formInputs.email || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="contactNumber" className="col-md-4 col-lg-3 col-form-label">Contact Number</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="contactNumber" type="text" className="form-control" id="contactNumber" value={formInputs.contactNumber || ""} onChange={onInputChangePhone} />
                              </div>
                            </div>

                            <h5 className="card-title" style={{ color: '#012970' }}>Address</h5>
                            <div className="row mb-3">
                              <label for="address" className="col-md-4 col-lg-3 col-form-label">Address 1</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="address" type="text" className="form-control" id="address" value={formInputs.address || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="address2" className="col-md-4 col-lg-3 col-form-label">Address 2</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="address2" type="text" className="form-control" id="address2" value={formInputs.address2 || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="city" className="col-md-4 col-lg-3 col-form-label">City</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="city" type="text" className="form-control" id="city" value={formInputs.city || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="state" className="col-md-4 col-lg-3 col-form-label">State</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="state" type="text" className="form-control" id="state" value={formInputs.city || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="country" className="col-md-4 col-lg-3 col-form-label">Country</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="country" type="text" className="form-control" id="country" value={formInputs.country || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save Changes</button>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default ProductMatrixCreationP2;
